import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'tileNiceDate',
    standalone: false
})
export class TileNiceDatePipe implements PipeTransform {
  transform(date: string): string {
    if (date.indexOf('-') === -1) {
      return date
    }
    const elemDate: string[] = date.split('-')
    const year: string = elemDate[0]
    const month: string = elemDate[1]
    const day: string = elemDate[2]
    return `${day}.${month}-${year.slice(2, 4)}`
  }
}
